import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const ObjectIdBadge = ({ objectId = "", onCopy = () => {}, compact = false, label = "ID" }) => {
  if (!objectId) return null;

  return (
    <Box display="flex" alignItems="center" minWidth={0} mt={compact ? 0 : 0.25}>
      <Tooltip title={objectId}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontFamily: "monospace",
            fontSize: compact ? 9 : 10,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: compact ? 150 : 190,
          }}
        >
          {label}: {objectId}
        </Typography>
      </Tooltip>
      <Tooltip title="Copy ObjectId">
        <IconButton
          size="small"
          aria-label={`Copy ObjectId ${objectId}`}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onCopy(objectId);
          }}
          sx={{ p: 0.25, ml: 0.25, color: "text.disabled" }}
        >
          <ContentCopyIcon sx={{ fontSize: compact ? 11 : 12 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ObjectIdBadge;
